import PropTypes from 'prop-types';
// Utils
import { cn } from '@repo/zolintra-utils';
// Components
import { Icon } from '../Icon/Icon';
// Styles
import styles from './CalendarEvent.module.css';

const ICON = {
  RemoteWorking: 'home',
  Leave: 'timerPause',
};

export function CalendarEvent({
  type, column, row, startTime, endTime, onClick, status, highlight, disabled,
}) {
  return (
    <>
      <div
        className={cn([
          styles.gridCell,
          styles.cellEvent,
          styles[type],
          styles[status],
        ])}
        style={{
          gridArea: `${row} / ${column.start} / ${row} / ${column.end}`,
        }}
        aria-label={`event-${startTime}-${endTime}-${column.start}-${column.end}-${row}`}
      >
        <button
          aria-label="event"
          type="button"
          onClick={onClick}
          disabled={disabled}
          className={styles.event}
        >
          <Icon icon={ICON[type]} className={styles.picto} />
        </button>

        {highlight ? (
          <Icon icon="star" className={styles.highlight} />
        ) : null}
      </div>

      {startTime === 'pm' ? (
        <span
          className={cn([styles[`start-${startTime}`], styles[type]])}
          style={{ gridArea: `${row} / ${column.start} / ${row} / ${column.start}` }}
        />
      ) : null}

      {endTime === 'am' ? (
        <span
          className={cn([styles[`end-${endTime}`], styles[type]])}
          style={{ gridArea: `${row} / ${column.start === column.end ? column.end : column.end - 1} / ${row} / ${column.end}` }}
        />
      ) : null}
    </>
  );
}

CalendarEvent.propTypes = {
  type: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  row: PropTypes.number.isRequired,
  column: PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number,
  }).isRequired,
  startTime: PropTypes.oneOf(['am', 'pm']).isRequired,
  endTime: PropTypes.oneOf(['am', 'pm']).isRequired,
  onClick: PropTypes.func,
  highlight: PropTypes.bool,
  disabled: PropTypes.bool,
};

CalendarEvent.defaultProps = {
  onClick: () => {},
  highlight: false,
  disabled: false,
};

export default CalendarEvent;
